var $9790b582a4a31826$exports = {};
$9790b582a4a31826$exports = {
    "Clear search": `Obri\u{161}i pretragu`
};


export {$9790b582a4a31826$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
